import { render, staticRenderFns } from "./SettingsOptionCard.vue?vue&type=template&id=4ae6b917&"
import script from "./SettingsOptionCard.vue?vue&type=script&lang=js&"
export * from "./SettingsOptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports